module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAQAAAATQsYqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAACjSURBVBjTbc8xDoJAEEbht0uyId7HA2zPFITQUNBYaKw8jdHCxoIGGjL0HMD7WJAQLQQCyLT/V7wxemFPLj2bpwFPXhZPRqlukzhKMrwlpSam+mfqqIipSa10JBTImqmjQihIpLMgPfnAwomEA8mlBzMLzGiJ5A26o8GPZEKgAXcOtERAg+fBcfzZzCoMV060gOfGWT7jYhaxP8aSrNDAWBL4AqywOJCACtk0AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTEwLTE4VDE0OjU0OjQ5KzAwOjAwuqrCNAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0xMC0xOFQxNDo1NDo0OSswMDowMMv3eogAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 0